import React, { useState, useRef } from 'react'
import { Modal, Form } from 'react-bootstrap'
import { toast } from 'react-toastify'
import { useParams } from '../../../Providers/ParamsProvider'
import { noAutofillProps } from '../Config/noAutofillProps'

const EMPTY_ELEMENT = { title: '' }

const AddEditFooterHeaderModal = ({ show, onHide, onSaved, isRegistrationProfit, editItem }) => {
    const { handleAddFooterHeader, handleUpdateFooterHeader } = useParams()
    const [footerHeader, setFooterHeader] = useState(EMPTY_ELEMENT)
    const [errorText, setErrorText] = useState(null)
    const [prevShow, setPrevShow] = useState(false)
    const firstInputRef = useRef(null)

    const isEditMode = !!editItem
    //w trybie edycji flagę bierzemy z edytowanego elementu, w dodawaniu z propsa (która sekcja otworzyła modal)
    const registrationProfit = isEditMode ? editItem.isRegistrationProfit : !!isRegistrationProfit

    if (show !== prevShow) {
        setPrevShow(show)
        if (show) {
            setFooterHeader(editItem ? { title: editItem.title } : EMPTY_ELEMENT)
            setErrorText(null)
        }
    }

    const validateData = () => {
        if (!footerHeader.title.trim()) {
            setErrorText('Uzupełnij tytuł!')
            return false
        }
        return true
    }

    const handleSave = async () => {
        if (!validateData()) {
            return
        }
        const success = isEditMode
            ? await handleUpdateFooterHeader({ headerId: editItem.headerId, title: footerHeader.title, isRegistrationProfit: registrationProfit })
            : await handleAddFooterHeader({ title: footerHeader.title, isRegistrationProfit: registrationProfit })

        if (success) {
            toast.success(isEditMode ? 'Zapisano zmiany.' : 'Dodano nowy nagłówek.')
            setFooterHeader(EMPTY_ELEMENT)
            setErrorText(null)
            onSaved?.()
            onHide()
        } else {
            toast.error(isEditMode ? 'Błąd podczas zapisu zmian!' : 'Błąd podczas dodawania nagłówka!')
        }
    }

    const buildTitle = () => {
        if (isEditMode) {
            return registrationProfit ? 'Edycja korzyści z rejestracji' : 'Edycja nagłówka stopki'
        }
        return registrationProfit ? 'Dodawanie korzyści z rejestracji' : 'Dodawanie nagłówka stopki'
    }

    return (<Modal size='lg' show={show} onHide={onHide} centered onEntered={() => firstInputRef.current?.focus()}>
        <Modal.Header closeButton>
            <Modal.Title>{buildTitle()}</Modal.Title>
        </Modal.Header>
        <Modal.Body>
            <div className="row mt-2 align-items-center">
                <div className="col-3"><span>Tytuł:</span></div>
                <div className="col">
                    <Form.Control
                        ref={firstInputRef}
                        name='title'
                        {...noAutofillProps}
                        value={footerHeader.title}
                        maxLength={200}
                        onChange={(e) => setFooterHeader({ ...footerHeader, title: e.target.value })}
                    />
                </div>
                <div className="col-auto">
                    <span className='error-text-color'>*</span>
                </div>
            </div>
            <div className={`d-flex justify-content-center mt-3 mb-3`}>
                <span className='error-text-color'>{errorText}</span>
            </div>
            <div className="d-flex flex justify-content-end  mt-4">
                <button className='btn-app-primary me-3' onClick={() => handleSave()}>{isEditMode ? 'Zapisz' : 'Dodaj'}</button>
                <button className='btn-app-secondary' onClick={() => onHide(null)}>Anuluj</button>
            </div>
        </Modal.Body>
    </Modal>)
}

export default AddEditFooterHeaderModal
